<div class="right-menu">
  <div class="top-right-menu">
    <div *ngIf="isTenant()">
      <input [placeholder]="getDateInputFormat()" bsDatepicker [id]="'calendar'" [name]="'calendar'" placement="left"
        class="right-menu-calendar" [bsConfig]="{ isAnimated: false }" [daysDisabled]="[0,1,2,3,4,5,6]"
        #dp="bsDatepicker" />
      <div class="tooltip-wrapper">
        <i class="material-icons-outlined calendar-icon" (mouseenter)="showTooltip('calendar')"
          (mouseleave)="hideTooltip('calendar')" (click)="toggleCalendar(dp)">
          today
        </i>
        <span class="custom-tooltip" [class.visible]="tooltipsVisible['calendar']">{{ 'Calendar' | localize }}</span>
      </div>
      <ng-template #popTemplate>
        <div>
          <app-notifications (closePopover)="onClosePopover()"></app-notifications>
        </div>
      </ng-template>
      <small class="bg-danger rounded-circle-noti" [class.disabled]="numberNotifications <= 0">
        {{ numberNotifications }}
      </small>
      <i class="material-icons-outlined" #notificationIcon [popover]="popTemplate" triggers="manual" placement="left"
        (click)="togglePopover($event)" #notificationPopover="bs-popover" (mouseenter)="showTooltip('notifications')"
        (mouseleave)="hideTooltip('notifications')" style="position: relative;">
        notifications
        <span class="custom-tooltip" [class.visible]="tooltipsVisible['notifications']">
          {{ 'Notifications' | localize }}
        </span>
      </i>
    </div>
  </div>
  <div class="bottom-right-menu">
    <div class="tooltip-wrapper">
      <i class="material-icons-outlined" (mouseenter)="showTooltip('userPreferences')"
        (mouseleave)="hideTooltip('userPreferences')" (click)="redirectUserConfiguration()">
        manage_accounts
      </i>
      <span class="custom-tooltip" [class.visible]="tooltipsVisible['userPreferences']">{{ 'UserPreferences' | localize
        }}</span>
    </div>
    <div class="tooltip-wrapper">
      <i class="material-icons-outlined" (mouseenter)="showTooltip('logout')" (mouseleave)="hideTooltip('logout')"
        (click)="logout()">
        power_settings_new
      </i>
      <span class="custom-tooltip" [class.visible]="tooltipsVisible['logout']">{{ 'Logout' | localize }}</span>
    </div>
  </div>
</div>